import { instance } from '@/libs/api/instance'

/**
 * Get list of wallets
 *
 * @param {object} params - Wallet filters and pagination
 * @param {string} [params.status] - ACTIVE|BLOCKED
 * @param {number} [params.isVisible] - 0|1
 * @param {number} [params.isFavourite] - 0|1
 * @param {string} [params.name] - Wallet name
 * @param {number} [params.page] - Page number
 * @param {number} [params.per-page] - Wallets per page
 * @param {string} [params.sort] - amount for ascending, -amount for descending
 * @param {object|null|string} [params.expand]
 * @param {object} [options] - Request cancellation options
 * @param {AbortSignal} [options.signal] - Cancels the request when aborted
 * @return {Promise<import('axios').AxiosResponse<any>>}
 */
export const getList = async (
  {
    status,
    isVisible,
    isFavourite,
    name,
    page,
    sort,
    expand,
    'per-page': perPage,
  },
  { signal } = {},
) => {
  return instance.get('/v3/wallet', {
    signal,
    params: {
      status,
      isVisible,
      isFavourite,
      name,
      page,
      sort,
      expand,
      'per-page': perPage,
    },
  })
}
